import moment from 'moment-timezone';
import React, { useMemo } from 'react';
import { DATE_FORMAT, DATE_TIME_FORMAT } from '@atlassian/cssxp-typescommon';

interface ComponentProps {
  /** Date formatted as ISO string ("1970-01-19T13:44:50.306Z") */
  date?: string | null;
  showTime?: boolean;
  format?: string;
  timeZone?: string;
}

const isNumber = (value: string) => /^\d+$/.test(value);

const convertToMilliSeconds = (date: string) => {
  switch (date.length) {
    case 10:
      return parseInt(date, 10) * 1000;
    case 13:
      return parseInt(date, 10);
    case 16:
      return parseInt(date, 10) / 1000;
    default:
      return 10000000000000000;
  }
};

const FormattedDateTimeZone = ({ date, showTime = false, format, timeZone }: ComponentProps) => {
  const dateFormat = useMemo(() => {
    if (format) return format;
    return showTime ? DATE_TIME_FORMAT : DATE_FORMAT;
  }, [format, showTime]);

  if (!date) {
    return <span />;
  }
  if (!timeZone) {
    timeZone = 'UTC';
  }

  return (
    <span>
      {isNumber(date)
        ? moment.utc(convertToMilliSeconds(date)).tz(timeZone).format(dateFormat)
        : moment.utc(date).tz(timeZone).format(dateFormat)}
    </span>
  );
};

export default FormattedDateTimeZone;
